import React, { ReactNode } from "react";

import styles from "./PageContainer.module.css";

function PageContainer({ children, draggable, pageBackground }: { children: ReactNode; draggable?: boolean; pageBackground?: string }) {
    return (
        <div className={draggable ? `${styles.container} ${styles.draggable}` : styles.container} style={{ background: `${pageBackground}` }}>
            <div className={styles.content}>{children}</div>
        </div>
    );
}

export default PageContainer;
